import { BaseFactory } from 'src/services/entity-factory/FactoryInterface';
import Metrics from 'src/entities/Metrics';

export interface ApiMetricsResponse {
  metrics: {
    totalInvested: number;
    totalFunded: number;
    registeredInvestors: number;
  };
}

export class MetricsFactory extends BaseFactory<Metrics> {
  public toEntity(args: ApiMetricsResponse): Metrics {
    return new Metrics({
      totalInvested: args.metrics.totalInvested,
      totalFunded: args.metrics.totalFunded,
      registeredInvestors: args.metrics.registeredInvestors
    });
  }
}


// WEBPACK FOOTER //
// ./src/services/entity-factory/factories/MetricsFactory.tsx